/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/display-name */
// TODO: Fix display name
// TODO: Fix accessibility

import { DetailedHTMLProps, HTMLAttributes, forwardRef } from 'react';
import { IMAGES_REPO } from '../../static-resources';
import './dropdown-toggle-button.component.scss';

interface DropdownToggleButtonComponentProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  open?: boolean;
}
export const DropdownToggleButtonComponent = forwardRef<
  HTMLDivElement,
  DropdownToggleButtonComponentProps
>(({ children, className, style, onClick }, ref) => {
  return (
    <div
      ref={ref}
      className={className}
      style={style}
      onClick={(e) => {
        e.preventDefault();
        if (onClick) onClick(e);
      }}
    >
      <div className="dropdown-toggle-button-input">
        <div className="dropdown-toggle-button-text">
          <img
            className={'dropdown-toggle-button-image'}
            src={IMAGES_REPO.SimpleArrow}
            loading="lazy"
            alt=""
            height={18}
            width={18}
          />
          {children}
        </div>
      </div>
    </div>
  );
});
